/**

   Grain Shader
   Add random rgb / monochrome pixels on top
   blend modes
   gold_noise from https://www.shadertoy.com/view/ltB3zD
   
 */

import vertexShader from './Ortho.vert.glsl';
import fragmentShader from './GrainShader.frag.glsl';
import {
  ShaderWithUniforms,
  GrainShaderUniforms,
} from '../../types/shader.types';

export const GrainShader: ShaderWithUniforms<GrainShaderUniforms> = {
  uniforms: {
    tDiffuse: {value: null},
    amount: {
      value: 0.5,
    },
    time: {value: 0},
  },
  vertexShader: vertexShader,
  fragmentShader: fragmentShader,
};
